module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/instagram_white-5c3fa4cf1dd72bcc3534ad3a3e77660d.svg";